import React from "react";
import { Box, Typography, Button } from "@mui/material";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";

const ErrorPage = ({
  message = "An unexpected error occurred. Please try again later.",
  onRetry,
}) => {
  const handleRetry = () => {
    // If a retry function is provided, call it.
    // Otherwise, refresh the page by default.
    if (onRetry && typeof onRetry === "function") {
      onRetry();
    } else {
      window.location.reload();
    }
  };

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      minHeight="80vh"
      px={2}
      textAlign="center"
      sx={{ backgroundColor: "background.default" }}
    >
      <ErrorOutlineIcon color="error" sx={{ fontSize: 80, mb: 2 }} />
      <Typography variant="h4" color="error" gutterBottom>
        Oops! Something went wrong.
      </Typography>
      <Typography variant="body1" color="textSecondary" mb={3}>
        {message}
      </Typography>
      <Button variant="contained" color="primary" onClick={handleRetry}>
        Retry
      </Button>
    </Box>
  );
};

export default ErrorPage;
